import { useFormContext } from "react-hook-form";
import { Radio } from "@material-tailwind/react";

// Radio bound to a single slot of an array field (e.g. `answer.0`): RHF's
// register onChange writes the radio value into that slot, and checked is
// derived from the form values by the caller (recipe P2 ref routing).
export default function RHFRadio({ name, ...props }) {
    const { register } = useFormContext();
    const { ref, ...rest } = register(name);

    return (
        <Radio
            {...rest}
            {...props}
            inputRef={ref}
        />
    );
}
